import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let LayoutHeaderComp;

class LayoutHeader extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: LayoutHeaderComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/layout-header-comp" */
            "../../../components/javascript/zcat-components/layout-header-comp"
        ).then(function(res) {
            LayoutHeaderComp = res.LayoutHeaderComp;
        }));

        
;
    }
}

export {LayoutHeader};

